import { STATUS_OPTIONS } from '../constants';
import { Stage } from '../models/EditableList';
import EditableListTab from './EditableListTab';
import type { EditableListConfig } from '../models/EditableList';
import { toCamelCase } from '../utilities/common';

interface StagesTabProps {
  stages: Stage[];
  onChange: (stages: Stage[]) => void;
  readOnlyIds?: string[];
}

const stagesConfig: EditableListConfig = {
  itemName: 'Stage',
  itemNamePlural: 'Stages',
  primaryField: {
    name: 'stage',
    label: 'Stage Name',
    type: 'text',
    required: true,
  },
  secondaryField: {
    name: 'status',
    label: 'Status',
    type: 'select',
    options: STATUS_OPTIONS,
    placeholder: 'Status',
    required: true,
  },
  stylePrefix: 'stage',
};

const StagesTab = ({ stages, onChange, readOnlyIds }: StagesTabProps) => {
  const createStage = (
    id: string,
    stageName: string,
    status: string,
  ): Stage => ({
    id,
    stage: toCamelCase(stageName),
    status,
  });

  const updateStage = (
    item: Stage,
    stageName: string,
    status: string,
  ): Stage => ({
    ...item,
    stage: toCamelCase(stageName),
    status,
  });

  return (
    <EditableListTab
      items={stages}
      config={stagesConfig}
      getPrimaryValue={(item) => item.stage}
      getSecondaryValue={(item) => item.status}
      onChange={onChange}
      createItem={createStage}
      updateItem={updateStage}
      readOnlyIds={readOnlyIds}
    />
  );
};

export default StagesTab;
